export default "__VITE_ASSET__B0Jhcf_U__"